<template>
    <form @submit="onSubmit" @reset="clearFilter">
      <div class="d-flex align-items-center">
        <div class="row flex-grow-1">
          <div class="col-6 d-flex align-items-center">
            <label class="me-2">Desde:</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="startDate"
              :max="max"
              placeholder="Fecha creación inicial"
            >
          </div>

          <div class="col-6 d-flex align-items-center">
            <label class="me-2">Hasta:</label>
            <input
              type="date" 
              class="form-control form-control-sm"
              v-model="endDate"
              :min="min"
              placeholder="Fecha creación final"
            >
          </div>
        </div>

        <div class="flex-shrink-1 ms-3">
          <button
            type="submit"
            class="btn btn-outline-primary btn-sm"
            :disabled="!enableSubmit"
          >
            Filtrar
          </button>

          <button
            v-if="!hideClear"
            type="reset"
            class="btn btn-outline-secondary btn-sm ms-2"
            :disabled="!enableReset"
          >
            Limpiar
          </button>
        </div>
      </div>
    </form>
</template>

<script>
export default {
  name: 'DateFilter',
  
  props: {
    initialRange: {
      type: Object,
      default: () => ({
        startDate: null,
        endDate: null
      })
    },
    hideClear: Boolean
  },

  data() {
    return {
      startDate: this.initialRange?.startDate?.split('T')[0] || null,
      endDate: this.initialRange?.endDate?.split('T')[0] || null
    }
  },

  computed: {
    enableSubmit() {
      return this.startDate && this.endDate
    },
    
    enableReset() {
      return this.startDate || this.endDate  
    },

    min() {
      return this.startDate ? this.startDate : null
    },

    max() {
      return this.endDate ? this.endDate : this.formatDateForInput(new Date())
    }
  },

  methods: {
    clearFilter() {
      this.startDate = null;
      this.endDate = null;
      this.$emit('clear')
    },

    onSubmit(evt) {
      evt.preventDefault()
      this.$emit('filter', {
        startDate: this.startDate + 'T00:00:00.000Z',
        endDate: this.endDate + 'T23:59:59.999Z'
      })
    },

    formatDateForInput(date) {
      return date.toISOString().split('T')[0]
    }
  }
}
</script>
